var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c(_vm.reCaptchaComponentVersion,_vm._g({tag:"Component",attrs:{"callback":_vm.callback,"index":_vm.index}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }